<template>
  <div class="animated fadeIn list-of-fa">
    <b-card v-if="showList">
      <div slot="header">List of Inventory Label 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="manageImages"><i class="fa fa-file-image-o"></i> Images</b-button>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print" >Form - Detail Info</b-dropdown-item>
            <b-dropdown-item @click="printlabel" >Label</b-dropdown-item>
            <b-dropdown-item @click="printlabels" :disabled="(selected.length==0)">Label({{selected.length}} yg terpilih) </b-dropdown-item>
            <b-dropdown-item @click="showlabelManualFrm" >Label Manual Input </b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
          <b-button variant="primary mr-1" @click="showFilter=!showFilter"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter" class="mb-1">
        <b-col lg="6">
            <b-row>
              <b-col lg="4">
                  <b-input-group >
                    <b-input-group-prepend><label>Inventory Status</label></b-input-group-prepend>
                    <b-form-select v-model="tblData.catgid" :plain="true" :options="categories"></b-form-select>
                  </b-input-group>
              </b-col>
              <!-- <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Issued/Usage</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tglu1" type="date" ></b-form-input>
                    <b-form-input v-model="tblData.tglu2" type="date" class="m-1" ></b-form-input>
                  </b-input-group>
              </b-col> -->
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Item Category</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.catgname"  ></b-form-input>
                  </b-input-group>
              </b-col>
            </b-row>     
            <b-row>
              <b-col lg="4">
                  <b-input-group >
                    <b-input-group-prepend><label >P.O Number &nbsp;</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomorpo" placeholder="Purch. Order#"></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>PO Receiv.Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-form-input v-model="tblData.tgl2" type="date" class="m-1" ></b-form-input>
                  </b-input-group>
              </b-col>
            </b-row>    
              <b-input-group >
                <b-input-group-prepend><label>Label/Number</label></b-input-group-prepend>
                <b-form-input v-model="tblData.asetid" placeholder="(% for wildcard)" class="mr-2"></b-form-input>
                <b-input-group-prepend><span class="pt-2 mr-1">Inven. Name</span></b-input-group-prepend>
                <b-form-input v-model="tblData.asdesc" placeholder=" Name/Description" style="width:40% !important;"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend><label>User | Location</label></b-input-group-prepend>
              <b-form-input v-model="tblData.asuser" placeholder="User"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCrewShow=true" ><i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
              <b-form-input v-model="tblData.aslocat" placeholder="Location" class="ml-2"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuAssetlocatShow=true"> <i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
            </b-input-group>
              <b-row>
                <b-col lg="8">
                    <b-input-group >
                      <b-input-group-prepend><label>Model/Type/Series</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.asmodel" placeholder="Model/Type/Series"></b-form-input>
                      <b-form-input v-model="tblData.asserial" placeholder="Serial Number" class="ml-1"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="4" > 
                   <div style="text-align:right;margin-top:5px;">
                    <b-button variant="success" size="sm" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                   </div>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#"  style="padding:0 !important;">Perintah Bayar</b-dropdown-item>
          <b-dropdown-item @click="rowPrintLabel(data.item)" href="#" style="padding:0 !important;">Print</b-dropdown-item>
        </b-dropdown>
      </template>
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-asetkey="data.item.asetkey"
            :checked="ischeckedjurnal(data.item.asetkey)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        

        <template v-slot:cell(asdatacq)="data">
          {{data.item.asdatacq| moment('D-MMM-YY')}} 
        </template>
        <template v-slot:cell(asdatuse)="data">
          <span v-if="(data.item.asdatuse)">{{data.item.asdatacq| moment('D-MMM-YY')}}</span> 
        </template>
        
        <!-- <template v-slot:cell(nomorpo)="data">
          <router-link :to="{ name: 'procurement.poinvpaymbyponumber', query: {ponumber: data.item.nomorpo}}" target="_blank">{{data.item.nomorpo}}</router-link>
        </template> -->
        <template v-slot:cell(aslocat)="data">
          <span v-if="(data.item.namalokasi)">{{data.item.kodelokasi}} | {{data.item.namalokasi}}</span>
          <span v-else>{{data.item.aslocat}}</span>
        </template>
        <template v-slot:cell(asuser)="data">
          <div v-if="(data.item.aspublic==1)"> Available (Not Used) </div>
          <div v-else>
              <span v-if="(data.item.crewname)">{{data.item.crewnik}} | {{data.item.crewname}}</span>
              <span v-else>{{data.item.asuser}} {{data.item.userdepartname}}</span>
          </div>
        </template>
        <template v-slot:cell(tglgaransi)="data">
          <span v-if="(data.item.txtgaransi)">{{data.item.txtgaransi}} &nbsp;</span>
          <span v-if="(data.item.tglgaransi)">Exp.{{data.item.tglgaransi| moment('D-MMM-YY')}}</span>
        </template>

      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Inventory Stock</span>
          </div>
        </b-col>        
      </b-row>
    </b-card>
    <b-card v-if="(showList==false)">
      <div slot="header">Inventory Labeled's Images 
        <div class="card-header-actions">
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
      <b-row >
          <b-col lg="6">
                <b-row no-gutters >
                  <b-col lg="5" >
                    <b-input-group class="pr-1">
                        <b-input-group-prepend><label>INV Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="7">                            
                    <b-input-group >
                        <b-form-input v-model="model.asdesc" readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="model.asmodel" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asyermad" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="model.asserial"  readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Group/Category</label></b-input-group-prepend>
                        <b-form-input v-model="model.nmcategory" readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input disabled v-model="model.asdatacq" type="date"  readonly></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
          </b-col>
          <b-col lg="6">
                <b-row no-gutters>
                  <b-col lg="7" >
                    <b-input-group >
                        <b-input-group-prepend><label>Warranty Desc./Note</label></b-input-group-prepend>
                        <b-form-input v-model="model.txtgaransi" readonly></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                    <b-input-group >
                        <b-input-group-prepend><span class="input-group-text">Expired Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.tglgaransi" type="date" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                    <b-form-input v-model="model.vendorinfo" disabled></b-form-input>                                        
                </b-input-group>
          </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" v-for="(item,index) in itemImg" :key="item.imgKey">
            <div style="text-align:center;">
              <b-card img-alt="Image" img-top>
                <img :src="itemImg[index].imgDataUrl">
                <div slot="footer">
                  <b-button variant="btn btn-primary mr-1" @click="toggleShowImg(index)"> <i class="fa fa-file-image-o"></i> Upload</b-button>
                  <b-button variant="btn btn-primary mr-1" @click="deleImage(index)"><i class="fa fa-trash"></i>
                  </b-button>
                  </div>
              </b-card>
            </div>

          <my-upload field="gambar" :noCircle="true" 
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="showImgTool"
              :width="450"
              :height="450"
              :url="imgUploadUrl"
              langType="en"
              :params="itemImg[index].imgParams"
              :headers="imgHeaders"
              img-format="png"></my-upload>
        </b-col>
      </b-row>
    </b-card>

    <b-modal v-model="showDtlForm" size="lg" title="Detail Info Inventory Labeled" header-bg-variant="primary" :centered="true" hide-footer>
        <b-card >
                <b-row >
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Inventory Number</label></b-input-group-prepend>
                        <b-form-input v-model="model.asetid" readonly></b-form-input>  
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">      
                    <b-input-group >
                        <b-input-group-prepend><label>Acquisition Date</label></b-input-group-prepend>
                        <b-form-input  v-model="model.asdatacq" type="date" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-input-group >
                    <b-input-group-prepend><label>Inventory Name</label></b-input-group-prepend>
                    <b-form-input v-model="model.asdesc" disabled></b-form-input>
                </b-input-group>
                <b-row>
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Model/type/Series</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.asmodel"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2" >
                    <b-input-group >
                        <b-input-group-prepend><span class="pt-2">Year &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="frmdata.asyermad"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="4">                            
                    <b-input-group >
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>S/N</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline" style="margin-top: 6px !important;"><span>S/N &nbsp;</span></b-input-group-prepend>
                        <b-form-input v-model="frmdata.asserial" placeholder="Serial Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row no-gutters>
                  <b-col lg="7" >
                    <b-input-group >
                        <b-input-group-prepend><label>Warranty Desc./Note</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.txtgaransi"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="5">                            
                    <b-input-group >
                        <b-input-group-prepend><span class="input-group-text">Expired Date</span></b-input-group-prepend>
                        <b-form-input v-model="frmdata.tglgaransi" type="date" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Brand/Merk</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.brand" ></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">                            
                    <b-input-group >
                        <b-input-group-prepend><label>Vendor/Supplier</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.vendorinfo" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>

                <b-row >
                  <b-col lg="6" >
                    <b-input-group >
                        <b-input-group-prepend><label>Other Information</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.otherinfo" placeholder="e.g Nomor Polisi, Computer Card, Unique Code"></b-form-input>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6">    
                    <b-input-group >
                        <b-input-group-prepend><label>Reference Doc.#</label></b-input-group-prepend>
                        <b-form-input v-model="frmdata.nomorpo" disabled></b-form-input>                                        
                    </b-input-group>
                  </b-col>
                </b-row>


            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="saveDtl()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="showDtlForm=false" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
    </b-modal>

        <b-modal v-model="showFormLabel" size="md" :hide-footer="true" title="Nomor Inventory Labeled akan cetak" :centered="true">                
                    <ul>
                        <li v-for="(nomor,idx) in arrLabel" :key="`label-${idx}`" >
                                {{nomor}} <b-link @click="delLabel(idx)" class="ml-2">  <i class="fa fa-trash"></i></b-link>
                        </li>               
                    </ul>
                    <div style="width:425px;">
                        <b-input-group>
                            <b-input-group-prepend><span class="pt-2">Tambah Nomor </span></b-input-group-prepend>
                            <b-form-input v-model="nomorlabel" class="ml-1" ></b-form-input>
                            <b-input-group-append>
                              <b-button class="btn btn-secondary ml-3" size="sm" @click="addLabel">
                                Add to list
                              </b-button>
                            </b-input-group-append>
                            <b-input-group-append>
                              <b-button class="btn btn-success ml-1" @click="printlabelManual">
                                Print
                              </b-button>
                            </b-input-group-append>

                        </b-input-group>
                    </div>
        </b-modal> 

        <b-modal v-model="lkuCrewShow" size="lg" :hide-footer="true" title="List of Employee" :centered="true">
            <lku-crew @click="onSelectLkuCrew" :formdata="lkuCrewData"></lku-crew>
        </b-modal>        
        <b-modal v-model="lkuAssetlocatShow" size="lg" :hide-footer="true" title="List of Location" :centered="true">
            <lku-assetlocat @click="onSelectLkuAssetlocat"></lku-assetlocat>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">
.list-of-fa {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
  .input-group {
      .input-group-prepend {
          label {
              width: 110px !important;
          }
      }
  }  
 
}
</style>

<script>
import 'babel-polyfill'; // es6 shim
import myUpload from 'vue-image-crop-upload';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import lkuCrew from "../lookup/lkuCrewFull";
import lkuAssetlocat from "../lookup/lkuAssetlocat";
import invLabel from "../../apis/inventorylabeled";
import dropdown from "../../data/dropdown";
toastr.init();

export default {
  components: { Loading,lkuCrew, lkuAssetlocat, myUpload},
  data() {
    return {
      showDtlForm:false,
      showFormLabel: false,
      showReport:false,
      reportUrl: null,
      arrLabel:[],
      nomorlabel:'',
      itemImg:[{imgDataUrl:'', imgKey:'0'},{imgDataUrl:'', imgKey:'1'},{imgDataUrl:'', imgKey:'2'},{imgDataUrl:'', imgKey:'3'}],
      imgParams:{name:'gambar'},
      imgHeaders:{},
      imgDataUrl: '',
      imgUploadUrl: '',
      img3:'',
      imgIndex:0,
      showImgTool:false,
      isLoading:false,
      lkuCrewData:{},
      lkuCrewShow:false,
      lkuAssetlocatShow:false,
      showDelConfirm: false,
      showList:true,
      showForm:false,
      showFilter:false,
      pagination:false,
      limit:20,
      tblData: {
        items: [],
        page: 1,
        limit: 20,
        total: 0,
        // tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,
        sortBy: 'asdatacq',
        sortDesc: true,outstand: ''
      },
      model:{asetkey:''},
      frmdata:{asetkey:''},
      YesNoAll: dropdown.YesNoAll,
      selected:[],selectedid:[],
      categories:[{value:'1', text:'Issued/Release'},{value:'0', text:'Inventory Stock'},{value:1, text:'--All--'}],
      printerReady:false,
      print2default: false,
      printers: [],
      selected_printer: ''
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:30px",
          thClass: "text-center",
        },
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "asetid",
            label: "INV Number",
            sortable: true
          },
          {
            key: "asdesc",
            label: "Name/Description",
          },
          {
            key: "brand",
            label: "Brand",
          },
          {
            key: "asmodel",
            label: "Model/Series",
          },
          {
            key: "asdatacq",
            thStyle: "width:80px",
            label: "Acquisition/ Receiv.Date",
            sortable: true
          },
          {
            key: "asdatuse",
            thStyle: "width:90px",
            label: "Inv.Issued Date",
            sortable: true
          },
          {
            key: "nomorpo",
            label: "Reference Doc.",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "nmcategory",
            label: "Category/Group",
            sortable: true
          },
          {
            key: "aslocat",
            label: "Location",
            sortable: true
          },
          {
            key: "asuser",
            label: "User",
            sortable: true
          },
          {
            key: "tglgaransi",
            label: "Warranty",
            sortable: true
          },
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: `${dims[i].value}Txt`,
        //     // thStyle: "width:100px",
        //     label: dims[i].text,
        //     sortable: true
        //   },)
        // }
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    catgid() {
      return this.tblData.catgid;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    catgid: function(newval){
      const catg = this.categories.find(c => c.value == newval)
      if (catg)
      {
        this.tblData.category=catg.text;
      }
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    }
  },
  // created: async function(){
  //     const [a] = await Promise.all([invLabel.category()]) ;
  //       this.categories = a.reduce((newArr,item) =>{
  //           newArr.push(item);
  //           return newArr;
  //       },[{ value: '', text: '--- ALL ---'}]);
  //     // this.adjustGroups = b;
  // },  
  methods: {
    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
    },
    checkedjurnal(item, record) {
      this.rowClicked(record);
      const asetkey = item.target.attributes["data-asetkey"].value;
      // const asetid = item.target.attributes["data-asetid"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === asetkey);
        if (!(findjv)){
          this.selected.push(asetkey);
          // this.selectedid.push(asetid);
          this.selectedid.push({asetid:record.asetid, childs: record.childs })
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === asetkey);
        this.selected.splice(findIdx, 1);
        this.selectedid.splice(findIdx, 1);
      }
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
      this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.assetList) {
            this.tblData[key] = filter.assetList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.assetList.tgl1 || '';
          this.tblData.tgl2=filter.assetList.tgl2 || '';
          this.showFilter=filtered;
          delete filter.assetList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;

                try {
                  const list = await invLabel.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;

                try {
                  const list = await invLabel.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  console.log(error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },    
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.catgid= '';
        this.tblData.asetid=  '';
        this.tblData.asdesc=  '';
        this.tblData.asmodel=  '';
        this.tblData.asserial=  '';
        this.tblData.nomorpo=  '';
        this.tblData.asuser=  '';
        this.tblData.aslocat=  '';
        this.tblData.outstand=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.tglu1=  '';
        this.tblData.tglu2=  '';
        this.tblData.DimVal=  '';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','catgid', 'category', 'catgname', 'nomorpo', 'outstand', 'asetid', 'asdesc', 'asmodel','asserial', 'asuser', 'aslocat', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal'];
      let filtered = false;
      const assetList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              assetList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          assetList.page=this.tblData.page;
          assetList.limit=this.tblData.limit;
          assetList.sortBy=this.tblData.sortBy;
          assetList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.assetList=assetList;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrintlabel(record) {
      this.rowClicked(record);
        this.printlabel();        
    },
    add: function() {
        this.saveFilter();
        router.push({name :'fixedasset.invlabelfrm'});
    },
    edit: function() {
      if (this.model.asetkey) {
          if (this.model.asdatuse) {
            this.saveFilter();
            router.push({name :'fixedasset.invlabelfrm', params: { asetkey: this.model.asetkey}});
          } else {
            toastr.warn(`Locked by INVENTORY MODUL, it'is not issued/released yet !`);
            this.showDtlForm=true;
            for (var key in this.model) {
                this.formdata[key] = this.model[key];
            }
            this.formdata.asdatacq = this.formdata.asdatacq ? moment(this.formdata.asdatacq).format('YYYY-MM-DD') : '';

          }
      } else {
            toastr.warn('Please select a row that want to be Edit!');
      }
    },
    save: function (callback) {
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            try {
              invLabel.save(this.frmdata);
              this.closeFrm();    
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
    },    
    saveDtl: function (callback) {
            // toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            try {
              invLabel.saveDtl(this.frmdata);
              this.showDtlForm=false;    
              setTimeout(() => {
                  this.refresh();              
              }, 500);       

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
    },    
    rowClicked(record, index) {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },
    print: async function()
    {
      if (this.model) {
          try {
              this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await invLabel.print(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printselected: async function()
    {
      if (this.selected) {
          try {
              this.isprintjv=false;
              this.showReport=true;
              this.reportUrl= await invLabel.printbills(this.selected);
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },
    printlabel: async function()
    {
      if (this.model) {
          try {
              var printWindow = window.open();
              printWindow.document.open('text/plain')

              // let zpl =  "^XA";
              // zpl += "^FO48,56^BQN,2,3^FDQA,"+ this.model.asetid +"^FS";
              // zpl += "^FO140,80^ADN,15,12^FD"+ this.model.asetid +"^FS";
              //  zpl += "^XZ";
              // printWindow.document.write(zpl);
              const fa = this.model;
              let cmds='' ;
              let childs;
              if (fa.childs) {
                childs=fa.childs.split(',');
                childs.forEach(childasetid => {
                  cmds +=  "^XA";
                  cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa.asetid+"-"+childasetid +"^FS";
                  cmds += "^FO140,80^ADN,15,12^FD"+ fa.asetid +"^FS";
                  cmds += "^FO140,120^ADN,15,12^FDC  -"+childasetid +"^FS";
                });
              }
              cmds +=  "^XA";
              cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa.asetid +"^FS";
              cmds += "^FO140,80^ADN,15,12^FD"+ fa.asetid +"^FS";
              cmds += "^XZ";
              printWindow.document.write(cmds);

              printWindow.document.close();
              printWindow.focus();
              printWindow.print();
              printWindow.close();
          } catch (error) {
            console.log(error);
            if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printlabels: async function()
    {
        if (this.selected) {
          try {
              let cmds="" ;
              let childs;
              var printWindow = window.open();
              printWindow.document.open('text/plain')
            this.selectedid.forEach(fa =>{
              if (fa.childs) {
                childs=fa.childs.split(',');
                childs.forEach(childasetid => {
                  cmds +=  "^XA";
                  cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa.asetid+"-"+childasetid +"^FS";
                  cmds += "^FO140,80^ADN,15,12^FD"+ fa.asetid +"^FS";
                  cmds += "^FO140,120^ADN,15,12^FDC  -"+childasetid +"^FS";
                });
              }
              cmds +=  "^XA";
              cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa.asetid +"^FS";
              cmds += "^FO140,80^ADN,15,12^FD"+ fa.asetid +"^FS";
              cmds += "^XZ";
            });
              printWindow.document.write(cmds);
              printWindow.document.close();
              printWindow.focus();
              printWindow.print();
              printWindow.close();
          } catch (error) {
            console.log(error);
            if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },
    showlabelManualFrm: function(){
        this.showFormLabel=true;
    },
    printlabelManual: function(){
        if (this.arrLabel) {
          try {
              let cmds="" ;
              var printWindow = window.open();
              printWindow.document.open('text/plain')
            this.arrLabel.forEach(fa =>{
              cmds +=  "^XA";
              cmds += "^FO48,56^BQN,2,3^FDQA,"+ fa +"^FS";
              cmds += "^FO140,80^ADN,15,12^FD"+ fa +"^FS";
              cmds += "^XZ";
              printWindow.document.write(cmds);
              printWindow.document.close();
              printWindow.focus();
              printWindow.print();
              printWindow.close();
            });
          } catch (error) {
            console.log(error);
            if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please Input Label that want to be Printed!');
        }

    },
    addLabel : function () {
        if (this.nomorlabel) {
            const ada =this.arrLabel.find(nomor =>nomor == this.nomorlabel);
            if (ada){
                // toastr.error(`Nomor Label "${this.nomorlabel}" sudah ada dalam List`)
                this.$bvModal.msgBoxConfirm(`Nomor Label "${this.nomorlabel}" sudah ada dalam List`, {
                    title: 'Apakah tetap akan ditambahkan',
                    size: 'md',buttonSize: 'sm',okVariant: 'danger',
                    okTitle: 'YES',cancelTitle: 'NO',footerClass: 'p-2',hideHeaderClose: false,centered: true
                  }).then(value => {
                      if (value==true) {
                        this.arrLabel.push(this.nomorlabel);
                        this.$forceUpdate();
                      }              
                    })
                    .catch(err => {
                      toastr.error(err);
                    });
            } else {
                this.arrLabel.push(this.nomorlabel);
            }
        } else {
                toastr.error(`Nomor Label belum diisi`)
        }
    },
    delLabel : function (index) {
        if (index > -1) {
            this.arrLabel.splice(index, 1);
        }
        this.model.nomorlabel= this.arrLabel.join(",");
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.expMode='ga';
            const response = await invLabel.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    onSelectLkuCrew: function (lkuData) {
        this.lkuCrewData=lkuData;
        this.lkuCrewShow=false;
        // this.model.crewinfo = lkuData.selected.crewnik.trim() + ' | ' + lkuData.selected.crewname.trim();
        this.tblData.asuser = lkuData.selected.crewname.trim();
        // this.model.crewkey = lkuData.selected.crewkey;
        // this.model.crewnik = this.model.crewnik;
        // this.model.jabatan = lkuData.selected.jabatan;
        // this.model.departemen = this.model.departemen;
        this.lkuCrewShow=false;
    },
    onSelectLkuAssetlocat: async function (_selected) {
        // this.model.lokasiinfo = _selected.kodelokasi.trim() + ' | ' + _selected.namalokasi.trim();
        this.tblData.aslocat = _selected.namalokasi.trim();
        // this.model.aslocatkey = _selected.aslocatkey;
        // this.model.kodelokasi = this.model.kodelokasi;
        // this.model.namalokasi = _selected.namalokasi;
        this.lkuAssetlocatShow=false;
    },
    manageImages: async function() {
      if (this.model.asetkey) {
          this.showList=false;
          const data = await invLabel.token();
          this.imgHeaders= data.headers;
          this.imgUploadUrl= `${data.baseURL}/inventorylabeled/uploadImage`;
          this.imgParams= {asetkey:this.model.asetkey};
          const imgOnSvr = await invLabel.images(this.model);
          for (let index = 0; index < 4; index++) {
            this.itemImg[index].imgKey=index;
            this.itemImg[index].imgDataUrl=''
            this.itemImg[index].imgParams= {asetkey:this.model.asetkey,imgKey:index };
            if (index<imgOnSvr.length) {
              this.itemImg[index].imgKey=imgOnSvr[index].imgKey;
              this.itemImg[index].imgDataUrl=imgOnSvr[index].imgBase64;
              this.itemImg[index].imgParams.imgKey=imgOnSvr[index].imgKey;
              // dibawah ini cara lain menampilkan gambar dari server tanpa di konversi ke base64            
              // this.itemImg[index].src=`${data.baseURL}/image/asset/${imgOnSvr[index].imgKey}`;
              // in HTML Template do like this: <img :src="itemImg[index].src">
            }
          }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    toggleShowImg(index) {
        this.imgIndex=index;
          console.log('this.imgIndex ',this.imgIndex);
          this.showImgTool = !this.showImgTool;
    },
    cropSuccess(imgDataUrl, field){
        console.log('-------- crop success --------', field);
        this.itemImg[this.imgIndex].imgDataUrl = imgDataUrl;
        console.log(imgDataUrl);
        console.log('content ',this[field]);
    },
    cropUploadSuccess(jsonData, field){
        console.log('-------- upload success --------');
        console.log(jsonData);
        console.log('field: ' + field);
    },
    cropUploadFail(status, field){
        console.log('-------- upload fail --------');
        console.log(status);
        console.log('field: ' + field);
    },

    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  },
};
</script>
